export function createAnalyser(ctx: AudioContext, opts?: { fftOrder?: number; smoothing?: number }) {
  const an = ctx.createAnalyser();
  if (opts?.fftOrder != null) {
    try { an.fftSize = 1 << Math.max(5, Math.min(15, Math.floor(opts.fftOrder))); } catch {}
  }
  if (opts?.smoothing != null) {
    try { an.smoothingTimeConstant = Math.max(0, Math.min(0.99, opts.smoothing)); } catch {}
  }
  return an;
}

export function setAnalyserFftOrder(an: AnalyserNode | null, order: number) {
  if (!an) return; try { an.fftSize = 1 << Math.max(5, Math.min(15, Math.floor(order))); } catch {}
}

export function setAnalyserSmoothing(an: AnalyserNode | null, smoothing: number) {
  if (!an) return; try { an.smoothingTimeConstant = Math.max(0, Math.min(0.99, smoothing)); } catch {}
}

// Buffer pools to avoid allocations per call
const FREQ_POOL = new WeakMap<AnalyserNode, Float32Array>();
const TIME_POOL = new WeakMap<AnalyserNode, Float32Array>();

export function getFloatSpectrum(an: AnalyserNode, out?: Float32Array): Float32Array {
  let arr = out;
  if (!arr) {
    const need = an.frequencyBinCount;
    const prev = FREQ_POOL.get(an);
    if (!prev || prev.length !== need) {
      arr = new Float32Array(need);
      FREQ_POOL.set(an, arr);
    } else {
      arr = prev;
    }
  }
  an.getFloatFrequencyData(arr as any);
  return arr;
}

export function getTimeDomain(an: AnalyserNode, out?: Float32Array): Float32Array {
  let arr = out;
  if (!arr) {
    const need = an.fftSize;
    const prev = TIME_POOL.get(an);
    if (!prev || prev.length !== need) {
      arr = new Float32Array(need);
      TIME_POOL.set(an, arr);
    } else {
      arr = prev;
    }
  }
  an.getFloatTimeDomainData(arr as any);
  return arr;
}
